var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "selectable-item border user-select-none px-4 py-3 d-flex align-items-center transition-base",
      class: [{ selected: _vm.selected }, { "cursor-pointer": !_vm.disabled }],
      style: _vm.disabled ? "opacity: 0.5" : "",
      on: {
        click: function ($event) {
          $event.preventDefault()
          !_vm.disabled ? _vm.$emit("click", _vm.item) : ""
        },
      },
    },
    [
      _c("b-img", {
        staticClass: "ml-3",
        attrs: {
          src: require(`@/assets/image/carbon-radio${
            _vm.selected ? "-active" : ""
          }.svg`),
        },
      }),
      _vm.item.image
        ? _c("BrbMedia", {
            attrs: {
              src: _vm.item.image,
              alt: _vm.item.title,
              width: "36",
              height: "36",
            },
          })
        : _vm._e(),
      _vm._t("default", function () {
        return [
          _c("span", { staticClass: "transition-base mr-3" }, [
            _vm._v(" " + _vm._s(_vm.item.title) + " "),
          ]),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }